export const LOGIN = {
    REQUEST: 'LOGIN_REQUEST',
    SUCCESS: 'LOGIN_SUCCESS',
    FAILED: 'LOGIN_FAILED',
    DEAD: 'LOGIN_DEAD',
    BEFORE_SUBMIT: 'LOGIN_BEFORE_SUBMIT',
};